export default __webpack_public_path__ + "static/media/project6.1c29d0c7.webp";